<template>
  <div
    :class="[
      'product-item',
      { selected: product.visa_product_id == selectedId },
    ]"
    @click="selectProduct"
  >
    <div class="original-product-mark" v-if="product.isOld">原签证</div>
    <img
      class="selected-icon"
      v-if="product.visa_product_id == selectedId"
      src="../../../assets/imgs/order/icon-copy-checked.png"
      alt=""
    />
    <div class="product-item-id">{{ product.visa_product_id }}</div>
    <div class="product-item-content">
      <div class="left-box">
        <div class="product-name">
          <div
            class="product-type"
            :style="{
              background: visaTypeMap[product.visa_type]
                ? visaTypeMap[product.visa_type].bgColor
                : visaTypeMap.qita.bgColor,
            }"
          >
            {{ product.visa_type }}
          </div>
          <span class="name-text">{{ product.product_name_short }}</span>
        </div>
        <div class="other-info">
          <div class="other-info-item">
            入境次数&nbsp;<span v-html="entryCN"></span>
          </div>
          <div class="other-info-item">
            有效期&nbsp;<span v-html="validityPeriodCN"></span>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="price-box">
          <div
            v-if="
              product.special_price
            "
            class="price-tag"
          ></div>

          <product-item-price-tips :product="product" :hide="!isLogin">
            <div class="price-num">
              <span class="currency">￥</span>
              <span class="price" v-if="isLogin">{{ product.special_price? product.special_price/100 : product.peer_price/100 }}</span>
              <span class="price" v-else>-</span>
            </div>
          </product-item-price-tips>

        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapMutations } from 'vuex';
import User from '../../../libs/user';
import productService from '../../../services/product-service';
import ProductItemPriceTips from '../../../pages/country/components/product-item-price-tips.vue';

export default {
  name: '',
  components: {
    ProductItemPriceTips,
  },
  props: {
    countryInfo: Object,
    product: Object,
    provinceCode: Number,
    selectedId: Number,
  },
  data() {
    return {
      visaTypeMap: {
        旅游签: {
          bgColor:
            'linear-gradient(135deg,rgba(123,179,242,1) 0%,rgba(84,148,221,1) 100%)',
        },
        商务签: {
          bgColor:
            'linear-gradient(135deg,rgba(94,211,187,1) 0%,rgba(61,187,162,1) 100%)',
        },
        探亲访友签: {
          bgColor:
            'linear-gradient(135deg,rgba(161,154,223,1) 0%,rgba(130,122,202,1) 100%)',
        },
        短期学习签: {
          bgColor:
            'linear-gradient(135deg,rgba(251,143,143,1) 0%,rgba(240,99,99,1) 100%)',
        },
        医疗签: {
          bgColor:
            'linear-gradient(135deg,rgba(238,214,104,1) 0%,rgba(237,184,80,1) 100%)',
        },
        访问签: {
          bgColor:
            'linear-gradient(135deg,rgba(116,208,247,1) 0%,rgba(72,185,233,1) 99%)',
        },
        免签: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        落地签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        过境签: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        香港L签过关服务: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        入台证: {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        展会签: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        EVUS登记: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        公证认证: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        公证: {
          bgColor:
            'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)',
        },
        签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)',
        },
        '国际驾照（KIDA）': {
          bgColor:
            'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)',
        },
        香港驾照: {
          bgColor:
            'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)',
        },
        入金证: {
          bgColor:
            'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)',
        },
        香港签注续签: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        },
        qita: {
          bgColor:
            'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)',
        }, // 此处故意用英文区分
      },
    };
  },
  computed: {
    isLogin() {
      return User.isLogin();
    },
    entryCN() {
      if (!this.product) return '';
      const cn = productService.getEntryCountCN(
        this.product.entry_count_n,
        this.product.entry_count_unit,
      );
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, text => `<span class="num">${text}</span>`);
    },
    validityPeriodCN() {
      if (!this.product) return '';
      const cn = productService.getValidityPeriodCN(
        this.product.validity_period_n,
        this.product.validity_period_unit,
      );
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, text => `<span class="num">${text}</span>`);
    },
    productShowPrice() {
      return productService.getSalesPrice(this.product);
    },
  },
  watch: {},
  created() {},
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    // 跳转到登录
    goToLogin() {
      this.SHOW_LOGIN_BOX();
    },
    selectProduct() {
      this.$emit('updateActive', this.product.visa_product_id);
    },
  },
};
</script>
  
  <style scoped lang="less">
.product-item {
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(47, 51, 61, 0.06);
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;
  width: 100%;
  .original-product-mark {
    position: absolute;
    left: -16px;
    top: 17px;
    width: 16px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #599fff 0%, #9cc4ff 100%);
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    font-size: 10px;
    color: #fff;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }

  .product-item-id {
    width: 90px;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 0px 4px 0px rgba(47, 51, 61, 0.06);
    font-size: 14px;
    color: #91999f;
  }

  .product-item-content {
    display: flex;
    flex-grow: 1;
    width: 80%;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    gap: 24px;

    .left-box {
      flex-grow: 1;
      overflow: hidden;
      .product-name {
        color: #2f333d;
        font-size: 0;
        display: flex;
        .product-type {
          height: 18px;
          padding: 0 4px;
          font-size: 12px;
          line-height: 1;
          color: #fff;
          display: inline-flex;
          align-items: center;
          justify-self: center;
          vertical-align: top;
          margin-top: 3px;
          margin-right: 4px;
          border-radius: 1px;
          max-width: 150px;
        }

        .name-text {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .other-info {
        margin-top: 10px;
        display: flex;
        align-items: center;
        .other-info-item {
          color: #91999f;
          font-size: 12px;
          line-height: 1;
          margin-right: 16px;
          /deep/ .num {
            color: #5f666e;
          }
        }
      }
    }

    .right-box {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .price-box {
        display: flex;
        align-items: center;
        .need-reject-label {
          width: 76px;
          height: 20px;
          margin-right: 4px;
          background: url(../../../assets/imgs/product-detail/visa-reject-refund-product.png)
            no-repeat center / 100% 100%;
        }
        .price-tag {
          width: 62px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          margin-right: 4px;
          background: url(../../../assets/imgs/product-detail/special-price-arrow-1.png)
            no-repeat center / 100% 100%;
          &.coupon {
            background: url(../../../assets/imgs/product-detail/special-price-coupon1.png)
              no-repeat center / 100% 100%;
            width: 98px;
          }
          &.new-people-coupon {
            background: url(../../../assets/imgs/product-detail/special-price-new-people-coupon1.png)
              no-repeat center / 100% 100%;
            width: 126px;
          }
          &.discount,
          &.free {
            background: url(../../../assets/imgs/product-detail/coupon-bg.png)
              no-repeat center / 100% 100%;
            // width: 126px;
            background-size: cover;
            padding: 0 4px;
            min-width: 90px;
            font-size: 14px;
            color: #fff;
          }
        }

        .price-num {
          display: flex;
          align-items: baseline;
          .currency {
            color: #ff8033;
            font-size: 18px;
            font-weight: 600;
          }

          .price {
            color: #ff8033;
            font-size: 24px;
            font-weight: 600;
          }
        }

        .login-btn {
          margin-left: 12px;
          width: 72px;
          height: 24px;
          border-radius: 1px;
          border: 1px solid #599fff;
          color: #599fff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          line-height: 1;
        }
      }
      .original-price {
        margin-top: 6px;
        font-size: 12px;
        line-height: 1;
        color: #91999f;
        .origin-price-number {
          text-decoration: line-through;
        }
      }
    }
  }
}

.selected {
  border: 1px solid #599fff;
  background: rgba(89, 159, 255, 0.08);
  .selected-icon {
    position: absolute;
    display: block;
    width: 34px;
    height: 34px;
    right: 0px;
    bottom: 0px;
  }
  .left-box {
    .other-info {
      .other-info-item {
        color: #2f333d;
        /deep/ .num {
          color: #599fff;
        }
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/ordering/components/order-edit-product-item.vue